import axios from 'axios';


const { ADMIN_API_URL } = process.env;
// Add auth token to requests if you have authentication
const adminApi = axios.create({
  baseURL: ADMIN_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


export const assignPracticeAssessment = async (data) => {
  try {
    const response = await adminApi.post('/assessment/assign-practice-assessment', data);
    return response.data;
  } catch (error) {
    console.error('Error calling assign practice assessment API:', error);
    throw error.response?.data || error;
  }
};